import { Condition } from './criteria';

export const MarketingAttributionModelTypes = [
  'FIRST_TOUCH',
  'MULTI_TOUCH',
  'LAST_TOUCH',
  'EVEN_DISTRIBUTION',
] as const;

export type MarketingAttributionModelType = typeof MarketingAttributionModelTypes[number];

export interface MarketingAttributionObjectFilters {
  campaignFilter?: Condition & {
    isCriteria: boolean;
  };
  campaignMemberFilter?: Condition & {
    isCriteria: boolean;
  };
  opportunityContactRoleFilter?: Condition & {
    isCriteria: boolean;
  };
}
export interface MarketingAttributionBasicModel extends MarketingAttributionObjectFilters {
  modelType: 'FIRST_TOUCH' | 'LAST_TOUCH' | 'EVEN_DISTRIBUTION';
}

export interface MarketingAttributionMultiTouchModel extends MarketingAttributionObjectFilters {
  modelType: 'MULTI_TOUCH';
  weights: {
    firstTouch: number;
    lastTouch: number;
    rest: number;
  };
}

export interface MarketingAttributionAction {
  actionType: 'REVENUE_ATTRIBUTION';
  actionParams: MarketingAttributionBasicModel | MarketingAttributionMultiTouchModel;
}

// Copy from '../utils' - importing is breaking client
export function assertEquivalentTypes<T, U>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ..._args: [T] extends [U] ? ([U] extends [T] ? [] : never) : never
): // eslint-disable-next-line @typescript-eslint/no-empty-function
void {}

assertEquivalentTypes<
  MarketingAttributionAction['actionParams']['modelType'],
  MarketingAttributionModelType
>();
